import axios from 'axios';
import { MediumBlog } from 'src/types/medium.blog';
import useSWR from 'swr';

const MEDIUM_FEEDS = 'MEDIUM_FEEDS';
// const ENDPOINT =
//     'https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/apsy';

const fetcher = () =>
    axios.get(
        `https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/apsy&count=3&api_key=n80olat8goaeegzpxlc6j3ks4brfb0gatrnhxfin`
    );
// axios.get(ENDPOINT);

export function useMediumApi() {
    const { data, error } = useSWR<{ data: MediumBlog }>(MEDIUM_FEEDS, fetcher);
    return { data, error };
}
